import { Dispatch, SetStateAction, useState } from 'react';
import { useGetUsersForFilterQuery } from '../../../../api/filter/dataFilterApi';
import { VendedorInfo } from '../../../../components/EmpresaComponents/EditarDealForm';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface Props {
    setVendedoresAgregados: Dispatch<SetStateAction<VendedorInfo[]>>;
    vendedoresAgregados: VendedorInfo[];
    dealId: number;
}

export function AddVendedorForm({ dealId, vendedoresAgregados, setVendedoresAgregados }: Props) {
    const [vendedorSelected, setVendedorSelected] = useState<number>(0);
    const [addVendedorError, setAddVendedorError] = useState<string | null>(null);

    const { data: vendedores } = useGetUsersForFilterQuery({
        role: "Vendedor",
        dealId: dealId.toString(),
        type: "exclude"
    }, { refetchOnMountOrArgChange: true });

    const addVendedor = () => {
        setAddVendedorError(null);

        if(vendedorSelected === 0) {
            setAddVendedorError("Debe seleccionar un vendedor")
            return;
        }

        // valida que no se agregue el mismo vendedor dos veces
        if(vendedoresAgregados.find((vendedor) => vendedor.vendedorId == vendedorSelected)) {
            setAddVendedorError("Este vendedor ya esta en agregado")
            return;
        }

        const vendedor = vendedores?.find((vendedor) => vendedor.id === vendedorSelected);

        const newVendedor: VendedorInfo = {
            vendedorName: vendedor?.nombre ?? "Sin nombre",
            vendedorId: vendedorSelected,
        };

        setVendedoresAgregados([...vendedoresAgregados, newVendedor]);

        // clear inputs
        setVendedorSelected(0);
    }

    const deleteVendedor = (index: number) => {
        vendedoresAgregados.splice(index, 1);

        setVendedoresAgregados([...vendedoresAgregados]);
    }

    return (
        <div className="flex-1 flex flex-col h-full">
            <p className="text-sms font-semibold">Agregar vendedores</p>

            <div className="flex items-center gap-x-2">
                <select
                    value={vendedorSelected}
                    onChange={(event) => {
                        const vendedorId = parseInt(event.target.value);

                        if(isNaN(vendedorId))
                            return;

                        setVendedorSelected(vendedorId);
                    }}
                    className="
                        w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                        font-semibold text-gray-600 text-sm">
                    <option value={0} hidden>Seleccionar vendedor</option>
                    {vendedores?.map((vendedor, index) => (
                    <option value={vendedor.id} key={index}>{vendedor.nombre}</option>
                    ))}
                </select>
                <button
                    onClick={addVendedor}
                    type="button"
                    className="bg-slate-700 border-0 border-gray-300 h-[26px] rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center text-sm text-white font-semibold">
                    Agregar
                </button>
            </div>

            <div className="flex flex-col overflow-hidden my-2 h-full">
                <p className="text-sm font-semibold">Vendedores agregados</p>

                <div className="flex-1 overflow-auto h-full">
                    {vendedoresAgregados.length === 0
                    ? <p className="text-sm font-semibold text-gray-600 italic text-center">No hay vendedores agregados</p>
                    : vendedoresAgregados.map((vendedor, index) => (
                        <div 
                            key={index}
                            className="flex gap-x-2 justify-between hover:bg-slate-50 p-2 rounded-md">
                            <div className="flex gap-x-1">
                                <div className="w-[20px] h-[20px] bg-gray-500 rounded-full"></div>
                                <p className="text-sm font-semibold">{vendedor.vendedorName}</p>
                            </div>
                            <div 
                                className="flex items-center h-[20px] cursor-pointer hover:bg-red-200 rounded-md" 
                                onClick={() => deleteVendedor(index)}>
                                <CloseRoundedIcon sx={{ height: 20, width: 20 }}/>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
            {addVendedorError && (
                <p className="valErrorText text-sm">{addVendedorError}</p>
            )} 
        </div>
    );
}
